import { render, staticRenderFns } from "./AppChatList.vue?vue&type=template&id=795de349&"
import script from "./AppChatList.vue?vue&type=script&lang=ts&"
export * from "./AppChatList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports